// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2H8uL{padding-top:2.5rem}._NwhC{margin-bottom:1.5rem;font-size:24px;font-size:1.5rem;font-weight:500;line-height:30px;line-height:1.875rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._NwhC{font-size:1.25rem;line-height:1.5625rem}}._3AhDQ{margin-bottom:1rem;font-size:16px;font-size:1rem;font-weight:500;line-height:20px;line-height:1.25rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._23gWi{width:100%;margin-bottom:1.5rem;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.RyNmh{margin-bottom:.75rem;margin-right:1rem;width:calc(33.33333% - .66667rem)}@media(max-width:767px){.RyNmh{width:100%}}.RyNmh:nth-child(3n){margin-right:0}@media(max-width:767px){.RyNmh:nth-child(3n){margin-right:0}}._2I8Ab{padding:.75rem 0 2.25rem}", ""]);
// Exports
exports.locals = {
	"section": "_2H8uL",
	"title": "_NwhC",
	"subtitle": "_3AhDQ",
	"materialsRow": "_23gWi",
	"materialButton": "RyNmh",
	"seeMore": "_2I8Ab"
};
module.exports = exports;
